import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import walkin from "../Media/walkin.mp4";
import walkinOgg from "../Media/walkin.ogg";
import DecorUpImage from "../Media/decorUp.png";
import DecorUpImageWebP from "../Media/decorUp.webp";
import DecorImageWebP from "../Media/decor.webp";
import DecorImage from "../Media/decor.png";
import VideomaskImage from "../Media/videomask.png";
import CheckWebP from "../Common/CheckWebP";

const styles = theme => ({
  root: {
    margin: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden"
  },
  card: {
    position: "relative"
  },
  videoCard: {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "100%",
    overflow: "hidden",
    zIndex: 1
  },
  decorDown: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    overflow: "hidden",
    zIndex: 3
  },
  mask: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    zIndex: 2,
    background: `url(${VideomaskImage})`
  },
  video: {
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1
  },
  decorUp: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100vw",
    overflow: "hidden",
    zIndex: 3
  }
});

class VideoCard extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <img
          src={CheckWebP() ? DecorImageWebP : DecorImage}
          alt={"decor"}
          className={classes.decorDown}
        />
        <div className={classes.mask} />
        <video
          loop={true}
          muted="muted"
          autoPlay
          className={classes.video}
          playsInline
          webkit-playsinline={"true"}
        >
          <source type="video/mp4" src={walkin} />
          <source type="video/ogg" src={walkinOgg} />
        </video>
        <img
          src={CheckWebP() ? DecorUpImageWebP : DecorUpImage}
          alt={"decorUp"}
          className={classes.decorUp}
        />
      </Card>
    );
  }
}
export default withStyles(styles)(VideoCard);
